import MarketingManagerPage from './marketing-manager-page';

export default function MarketingManagerGridPage() {
  return <MarketingManagerPage />;
}
